export default {
  healthFunds: [
    {
      value: "AC4B49B0-FA1E-4B46-BCF8-71459CF7DD9F",
      text: "ACA Health Benefits Fund"
    },
    {
      value: "285B3AD2-28A9-4366-AF89-5ECF2BE6F7F6",
      text: "Australian Health Management Group"
    },
    {
      value: "F6EE2CEA-F6CE-4834-9DA6-9CE028815943",
      text: "Australian Unity Health Ltd"
    },
    {
      value: "FC59E503-9599-4677-B0FB-73AAFAAED046",
      text: "BUPA Australia Health"
    },
    {
      value: "27C38FE3-7C32-436F-B735-ADA8C5D9E6B0",
      text: "CBHS Friendly Society"
    },
    {
      value: "B063881B-6D7F-454D-872F-465CCE644558",
      text: "Central West Health Cover"
    },
    {
      value: "C93F9080-417A-4859-9288-88AE3FC8E13D",
      text: "Cessnock District Health Benefits Fund Ltd"
    },
    {
      value: "04C105CE-7A0D-4143-B74C-1DADAC83605D",
      text: "CUA Health Limited"
    },
    {
      value: "A830ABD6-18F2-4AE9-B468-601E2C073CC0",
      text: "Defence Health"
    },
    {
      value: "7EC06B56-F13B-406B-B2BC-61D2A6582045",
      text: "Doctors Health Fund"
    },
    {
      value: "EB535EA4-CFEF-47A7-B4EC-E8515937F182",
      text: "Druids Friendly Society"
    },
    {
      value: "269E0719-DB74-4166-BA37-DF140B996D31",
      text: "Frank Health Insurance"
    },
    {
      value: "225CCFF8-9099-48FA-A621-DE7C87B95E48",
      text: "GMF Health"
    },
    {
      value: "F067E86E-9EE9-41D2-878D-68393D04CBDB",
      text: "GMHBA Ltd"
    },
    {
      value: "E4A5B1A8-9FF2-434E-A1B8-DD89890365B3",
      text: "Grand United Corporate Society"
    },
    {
      value: "8BECBCB0-73AF-423D-86F7-7E8BB222370E",
      text: "GU Health"
    },
    {
      value: "DFDBFBF1-0EA9-4A3C-A0DA-7031A83D94B6",
      text: "HBA"
    },
    {
      value: "B287860D-4ECC-4B69-BD4E-BBA0D5B5B155",
      text: "HBF Health Funds Inc"
    },
    { value: "420DC008-4D88-4E06-A6CB-42F874B04B71", text: "HCF" },
    {
      value: "6393CC89-9FB2-4299-AB18-14D89B24BE58",
      text: "Health Care Insurance"
    },
    {
      value: "CB8E7D47-7A2E-4F30-97DC-E6DBEACCC04E",
      text: "Health Insurance Fund of Australia Limited"
    },
    {
      value: "68E0CC1E-11C1-4950-AC33-6D97F794C545",
      text: "Health Partners"
    },
    {
      value: "CABB0014-D3BD-4057-97ED-7B7E232177A9",
      text: "health.com.au"
    },
    {
      value: "FB6388A8-FE43-400A-B5F5-98C02FC8A42C",
      text: "Healthguard Health Benefits (including GMF Health)"
    },
    {
      value: "0BDA8E16-F856-41E9-9A2B-4E23AAF39E45",
      text: "IOOF Health"
    },
    {
      value: "33FC5271-DEF7-44A2-B6B3-57B719F2316A",
      text: "Latrobe Health Services Inc"
    },
    {
      value: "00CB85DA-5223-4CE3-BFEC-BDC9EE2FC482",
      text: "Manchester Unity Australia"
    },
    {
      value: "9C2EC124-8BC0-454E-AF6E-41E3B2ECB47D",
      text: "MBF Australia Ltd"
    },
    {
      value: "EC9603BF-3AD8-4053-BC62-BF15E78EDE6E",
      text: "MBF Health Pty Ltd"
    },
    {
      value: "BA5313A2-531B-48D0-A300-8129CAAEB9DE",
      text: "Medibank Private Ltd"
    },
    {
      value: "11E76E9F-0DBD-47A9-B868-7B73DF68E865",
      text: "Mildura District Hospital Fund Ltd"
    },
    {
      value: "AB464F53-96F1-4FB9-9714-0CC150BAF0E6",
      text: "Mutual Community"
    },
    {
      value: "F4DDC043-2D97-4210-8A8A-87CFF644B040",
      text: "Navy Health"
    },
    {
      value: "D1E64F26-8C7E-4240-A43C-65A519C7E956",
      text: "NIB Health Funds Ltd"
    },
    {
      value: "ED43D492-E46C-4228-9CD3-716FC6075201",
      text: "Onemedifund"
    },
    {
      value: "18564887-E4F0-4FEA-A98E-9805E61B4B6F",
      text: "Peoplecare Health Insurance"
    },
    {
      value: "1FD1F222-0B83-495B-A426-3ADDAF976641",
      text: "Phoenix Health Fund Ltd"
    },
    {
      value: "D38C0D48-6389-45EC-8A20-8833F5B411F7",
      text: "Police Health"
    },
    {
      value: "51B8008C-36D9-4D24-B2DD-3F93216D0D6F",
      text: "Queensland Country Health Ltd"
    },
    {
      value: "FF2EC1B6-9590-4EBD-A383-8717DA8C1D1C",
      text: "Reserve Bank Health Fund"
    },
    {
      value: "4BEB4B68-E4B8-4299-9AF4-F318467A9514",
      text: "RT Health Fund Ltd"
    },
    {
      value: "9C161B81-4C6D-4FA9-9EFD-3CE5315A1C60",
      text: "St.LukesHealth"
    },
    {
      value: "FCF80D55-A3E5-4EFB-9BD5-50FF3DB5FDC1",
      text: "Teachers Federation Health (NSW)"
    },
    {
      value: "2ED3F9B2-845B-42F4-BBBB-93BC8DC47826",
      text: "Teachers Union Health"
    },
    {
      value: "047F4DE7-33D0-4354-9BBB-421E943B4016",
      text: "The Doctors Health Fund Ltd"
    },
    {
      value: "3BAC80E8-D2A4-4A72-A092-1141F8B252D2",
      text: "Transport Friendly Society"
    },
    {
      value: "A6D398BC-C294-43A3-8929-CA318AB65292",
      text: "Union Shopper Health"
    },
    {
      value: "9E36ECC6-8ABB-4615-B081-8EC34A3FE45D",
      text: "Westfund"
    },
    {
      value: "00000000-0000-0000-0000-000000000000",
      text: "None"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/jsonData/HealthFunds.js